export function getCompleteAddress(data) {
	return data.address + ', ' + data.city + ', (' + data.province + ')';
}
